import { HoverableLink } from '@paywithextend/components'
import Button, { ButtonProps } from 'ext-ui/components/Button/Button'
import React from 'react'
import { useDispatch } from 'react-redux'
import ErrorList from 'src/components/ErrorList/ErrorList'
import { useTranslate } from 'src/localization/Trns'
import { closeModal } from 'src/navigation/Lnk'
import { css } from 'styled-components'

type ModalDialogButtonVariant = ButtonProps['variant']

interface ModalDialogFormProps {
  children: React.ReactNode
  className?: string
  formOnSubmit: (e: React.FormEvent) => void
  actionButtonLabel: React.ReactNode
  actionButtonLoading: boolean
  actionButtonVariant?: ModalDialogButtonVariant
  cancelButtonLabel: React.ReactNode
  cancelButtonVariant?: ModalDialogButtonVariant
  cancelButtonOnClick?: () => void
  isFormValid: boolean
  error?: string
  showCancelAsLink?: boolean
}

const ModalDialogForm: React.FC<ModalDialogFormProps> = (props) => {
  const translate = useTranslate()

  const dispatch = useDispatch()

  const { children } = props

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <form
        onSubmit={(e: React.FormEvent): void => {
          e.preventDefault()
          props.formOnSubmit(e)
        }}
      >
        {children}
        {props.error !== undefined && (
          <ErrorList
            errors={[props.error]}
            css={css`
              margin-top: 10px;
              margin-bottom: 10px;
            `}
          />
        )}
        <div
          css={css`
            display: flex;
          `}
        >
          <Button
            variant={props.actionButtonVariant || 'severe'}
            type="submit"
            loading={props.actionButtonLoading}
            disabled={props.actionButtonLoading || !props.isFormValid}
            testId={'submitBtn'}
          >
            {props.actionButtonLabel}
          </Button>
          {props.showCancelAsLink ? (
            <HoverableLink
              key={0}
              css={css`
                display: flex;
                align-items: center;
                float: right;
                margin-left: 20px;
              `}
              ariaLabelSource={'Cancel'}
              onClick={
                props.cancelButtonOnClick ||
                ((): void => {
                  dispatch(closeModal())
                })
              }
            >
              {translate('Cancel')}
            </HoverableLink>
          ) : (
            <Button
              variant={props.cancelButtonVariant || 'secondary'}
              type="button"
              onClick={
                props.cancelButtonOnClick ||
                ((): void => {
                  dispatch(closeModal())
                })
              }
              css={css`
                margin-left: 20px;
              `}
              testId={'cancelBtn'}
            >
              {props.cancelButtonLabel}
            </Button>
          )}
        </div>
      </form>
    </div>
  )
}

export default ModalDialogForm
